/* global localStorage, document */
import { h } from 'preact';
import { useEffect } from 'preact/hooks';

export const themeToggle = function(p) {
  const lsname = p.lsName || 'night-theme';
  useEffect(() => setTheme(undefined, lsname), [p.lsName]);
  return h('div', { class: 'ctl-component' },
    h('button', { onClick: setTheme.bind(0, 0, lsname) }, 'Day'),
    h('button', { onClick: setTheme.bind(0, 1, lsname) }, 'Night'),
  );
};
function setTheme(isNight, lsname) {
  if (isNight === undefined) isNight = localStorage.getItem(lsname);
  if (/1/.test(isNight)) document.body.classList.add('night');
  else document.body.classList.remove('night');
  localStorage.setItem(lsname, isNight);
}
